// Return a new state with the key set to the payload
export const update = state => key => ({ payload }) => ({
  ...state,
  [key]: payload,
});

export const updatePath = state => ([firstProp, ...rest]) => ({ payload }) => ({
  ...state,
  [firstProp]: rest.length ? updatePath((state || {})[firstProp])(rest)({ payload }) : payload,
});

export const beginRequest = ([firstProp, ...rest]) => state => ({
  ...state,
  [firstProp]: rest.length ? beginRequest(rest)(state[firstProp]) : state[firstProp] + 1,
});

export const completeRequest = ([firstProp, ...rest]) => state => {
  if (!rest.length) {
    if (state[firstProp] > 0) {
      return {
        ...state,
        [firstProp]: state[firstProp] - 1,
      };
    }

    return state;
  }

  return {
    ...state,
    [firstProp]: completeRequest(rest)(state[firstProp]),
  };
};

export const startRequest = state => {
  if (!state || !state.hasOwnProperty("requestsInProgress")) {
    return state;
  }

  ++state.requestsInProgress;
  return state;
};

export const finishRequest = state => {
  if (!state || !state.hasOwnProperty("requestsInProgress")) {
    return state;
  }

  if (state.requestsInProgress > 0) {
    --state.requestsInProgress;
  }

  return state;
};
